<script>

  export default {
    props: {
      options: {
        type: null,
        default: () => [
          { value: 1, text: 'My projects' },
          { value: '', text: 'All projects' },
          { value: 0, text: 'No owner' },
        ]
      },
      defaultFilters: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        ownerFilter: 1,
        boundCollapse: true,
      }
    },
    async created() {
      // apply defaults
      if (this.defaultFilters || this.defaultFilters === null){
        this.ownerFilter = this.defaultFilters
      }

      // dynamically create watcher AFTER init for future changes
      this.$watch('ownerFilter', function () {
        this.$emit('filter', {
          is_owner: this.ownerFilter,
        })
      })
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-owner
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by Owner</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
    </div>
    <FabricCollapse
      id="accordion-owner"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div class="block-content">
        <FabricRadio 
          v-for="(option, index) in options" 
          :key="`fab-op-${index}`" 
          v-model="ownerFilter"
          is-numerical
          group-name="ownerTypes"
          class="tw-mt-2 tw-mb-2"
          :value="option.value">
          {{ option.text }}
        </FabricRadio>
      </div>
    </FabricCollapse>
  </div>
</template>
